import { render, staticRenderFns } from "./workFlowTemplateManage.vue?vue&type=template&id=4ff52ffb&scoped=true&"
import script from "./workFlowTemplateManage.vue?vue&type=script&lang=js&"
export * from "./workFlowTemplateManage.vue?vue&type=script&lang=js&"
import style0 from "./workFlowTemplateManage.vue?vue&type=style&index=0&id=4ff52ffb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff52ffb",
  null
  
)

export default component.exports